<template lang="pug">
app-page-layout(fix-header)
  app-table-page-layout
    template(#toolbar-left)
      //- app-input-search(@search='handleQuickSearch')
      app-search(
        v-model="filters"
        :fields="filterFieleds"
        @search="handleQuickSearch"
        keywordPlaceholder="请输入关键字"
      )
      a-button.ml2(@click='$refs.table.reload()') 刷新
    template(#toolbar-right)
        //- a-button(type="primary" icon="plus" @click="handleCreate") 新建
        //- a-button.ml2(
        //-   type="danger"
        //-   @click="handleDeleteBatch"
        //-   :disabled="!canDeleteBatch"
        //-   :loading="deleteBatchLoading"
        //- ) 批量删除
    app-table(
      ref="table"
      model-name="car-records"
      url="/prj/car-records/page"
      :params="params"
      :visibles="columns"
      @select="handleSelectChange",
      @selectChange="handleSelectChange",
      @change="handleSelectChange",
      @loaded="handleSelectChange"
    )
      //- :columns-customsize="columnsCustomsize"
      template(#orderNumber="{text, record}")
        app-link-btn(:to="'./car-records/' + record.id") {{ text }}
      //- template(#action="{record}")
        app-action-column
          //- app-link-btn(@click="handleEdit(record)") 编辑
          app-link-btn-delete(@confirm="(cb) => handleDelete(record, cb)") 删除
    CreateAndEdit(ref="createAndEdit" @modal-success="$refs.table.reload()")
</template>

<script>
import { GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
import CreateAndEdit from './Modal/CreateAndEdit';
export default {
  name: 'KeepAliveXxxx',
  components: {
    CreateAndEdit,
  },
  data() {
    return {
      columns: [
        // 'orderId',
        'orderNumber',
        // 'ticketId',
        // 'ticketNumber',
        // 'carId',
        'driverName',
        'porterNames',
        'installerNames',
        'deliveryTime',
      ],
      search: null,
      // 批量删除
      canDeleteBatch: false,
      deleteBatchLoading: false,
      // 筛选
      filters: {},
      filterFieleds: [],
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
    }),
    params() {
      return {
        // search: this.search,
        ...this.filters,
        projectId: this.project.id,
      };
    },
  },
  created() {
    this.initFilters();
  },
  methods: {
    reload() {
      this.$refs.table.reload();
    },
    handleQuickSearch(keyword) {
      this.search = keyword;
    },
    // 新增
    handleCreate() {
      this.$refs.createAndEdit.show();
    },
    // 修改
    handleEdit(record) {
      this.$refs.createAndEdit.show(record);
    },
    columnsCustomsize(columns, config) {
      columns.push({
        uid: 'action',
        dataIndex: 'action',
        title: '操作',
        width: '8rem',
        fixed: config.fixedActionColumn ? 'right' : null,
      });
      return columns;
    },
    // 启用/禁用
    async handleEnable(record, cb, enabled) {
      //inspplans
      await this.$restful(
        `PUT:/prj/car-records/${record.id}/enables`,
        { enabled },
        { params: { enabled } },
      );
      cb();
      this.$message.success('操作成功!');
      this.$refs.table.reload();
    },
    // 删除
    async handleDelete(record, cb) {
      await this.$restful(`DELETE:/prj/car-records/${record.id}`);
      cb();
      this.$message.success('删除成功!');
      this.$refs.table.reload();
    },
    // 批量删除
    handleDeleteBatch() {
      this.deleteBatchLoading = true;
      const ids = this.$refs.table.getSelection()?.map((item) => item.id);
      this.$restful(`DELETE:/prj/car-records`, {
        ids: ids,
      })
        .then(() => {
          this.$refs.table.reload();
        })
        .finally(() => {
          this.deleteBatchLoading = false;
        });
    },
    // 是否可以批量删除
    handleSelectChange(select) {
      // console.log(select?.selectedRowKeys);
      if (select?.selectedRowKeys?.length) {
        this.canDeleteBatch = true;
      } else {
        this.canDeleteBatch = false;
      }
    },
    // 初始化筛选条件
    initFilters() {
      this.filterFieleds = [
        {
          name: 'carId',
          component: 'app-remote-select',
          width: '150px',
          placeholder: '车辆',
          api: '/prj/cars/list',
          params: { projectId: this.project.id },
          field: { name: 'id', label: 'plate' },
        },
        {
          name: 'crewId',
          component: 'app-remote-select',
          width: '150px',
          placeholder: '随车人员',
          api: '/prj/crews/list',
          params: { projectId: this.project.id },
        },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
// .
</style>
